// extracted by mini-css-extract-plugin
export var sectionTitle = "SectionTitle-module--sectionTitle--1Lw2f";